<template>
  <div>
    <b-row align-v="center" align-h="between" v-if="!firstLoad" class="pb-2">
      <b-col
        cols="auto"
        md="auto"
        class="d-flex align-items-center text-left p-0"
      >
        <b class="color_second" v-text="title" />
        <b-badge
          v-if="totalRows && showTotalRowsCount"
          pill
          class="fontSize-15 ml-1 bg_alert text-white"
        >
          {{ totalRows }}
        </b-badge>
      </b-col>
      <b-col
        cols="auto"
        md="auto"
        class="p-0 d-flex align-items-center justify-content-end color_second"
      >
        <div v-if="showQuickFilter" class="d-md-block d-none">
          <InputGroup
            :clearInput="clearInputGroup"
            @submit="quickFilter"
            @reset="handleDeleteFilterCache"
          />
        </div>
        <slot name="buttons" />
        <span
          v-if="isImportExcel && isAdmin(permissions, ['admin'])"
          @click="!isLoading && importExcel()"
          v-b-tooltip.hover
          :title="isImportExcelTooltip"
          class="ml-2"
        >
          <mdicon
            name="cloud-upload-outline"
            size="24"
            class="cursor_pointer"
          />
        </span>
        <span
          v-if="exportable && isAdmin(permissions)"
          @click="!isLoading && !exportableLoading && exportData()"
          v-b-tooltip.hover
          title="خروجی اکسل"
          class="ml-2"
        >
          <mdicon
            v-if="exportableLoading"
            name="loading"
            size="24"
            class="spinner center"
          />
          <mdicon
            v-else
            name="file-excel-outline"
            size="24"
            class="cursor_pointer"
          />
        </span>
        <span
          v-if="refreshButton"
          @click="!isLoading && getItems()"
          v-b-tooltip.hover
          title="به‌روز رسانی لیست"
          class="ml-2"
        >
          <mdicon
            v-if="isLoading"
            name="loading"
            size="24"
            class="spinner center"
          />
          <mdicon v-else name="refresh" size="24" class="cursor_pointer" />
        </span>
        <span
          v-if="filterCatch && Object.values(paramsData).length"
          @click="!isLoading && handleDeleteFilterCache()"
          v-b-tooltip.hover
          title="حذف فیلترها"
          class="ml-2"
        >
          <mdicon
            v-if="deleteFilterLoading"
            name="loading"
            size="24"
            class="spinner center"
          />
          <mdicon
            v-else
            name="filter-remove-outline"
            size="24"
            class="cursor_pointer"
          />
        </span>
        <span
          v-if="hasFilter && filterHeaders.length"
          @click="!isLoading && showFilter()"
          v-b-tooltip.hover
          title="فیلترهای جستجو"
          class="ml-1"
        >
          <mdicon name="filter-outline" size="24" class="cursor_pointer" />
        </span>
      </b-col>
      <b-col v-if="showQuickFilter" cols="12" md="12" class="d-md-none mt-3">
        <InputGroup
          :clearInput="clearInputGroup"
          @submit="quickFilter"
          @reset="handleDeleteFilterCache"
        />
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col :class="classData" class="px-0">
        <LoadingSpinner :loading="isLoading || firstLoad" />
        <div v-if="!isLoading">
          <b-card
            v-for="(item, i) in items"
            :key="i"
            class="mb-3 border-0 bg-transparent"
            no-body
          >
            <b-row class="m-0" v-if="html">
              <div
                class="px-2 d-flex justify-content-center align-items-center"
              >
                {{ i + 1 }}
              </div>
              <b-col
                class="d-flex justify-content-center align-items-center"
                v-for="(label, y) in Object.keys(allowFields)"
                :key="y"
              >
                {{ allowFields[label] }} : {{ deepFind(item, label) }}
              </b-col>
              <b-col class="d-flex justify-content-center align-items-center">
                <slot name="actions" :item="item" />
              </b-col>
            </b-row>
            <b-row class="m-0" v-else>
              <slot name="html" :item="item" />
            </b-row>
          </b-card>
          <b-alert
            show
            variant="danger"
            v-if="!items.length && !firstLoad"
            v-text="'هیچ موردی برای نمایش وجود ندارد'"
          />
          <PaginationSearch
            :allowPaginate="allowPaginate"
            :total="totalRows"
            :total_pages="total_pages"
            :perPage="perPage"
            v-model="page"
            @input="paging"
          />
        </div>
      </b-col>
      <FilterBox
        v-if="filter"
        ref="advanceFilter"
        :headers="filterHeaders"
        @getFilterItems="getFilterItems"
        @getFilterDate="getFilterDate"
        @closeAdvanceFilter="showFilter"
      />
    </b-row>
  </div>
</template>
<script>
import PaginationSearch from "@/components/base/paganationSearch";
import advanceFilter from "@/components/base/advanceFilter";
import filterMethods from "@/mixin/filterMethods.js";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import InputGroup from "@/components/global/InputGroup";
import FilterBox from "@/components/global/FilterBox";
import { pathOr } from "ramda";
import { generateStoreGetters, isAdmin } from "@/shared/utils";

export default {
  extends: filterMethods,
  components: {
    PaginationSearch,
    advanceFilter,
    FilterBox,
    LoadingSpinner,
    InputGroup,
  },
  props: {
    isImportExcelTooltip: {
      type: String,
      default: "",
    },
    sampleDownload: {
      type: String,
      default: "",
    },
    isImportExcel: {
      type: Boolean,
      default: false,
    },
    html: {
      type: Boolean,
      default: false,
    },
    filterCatch: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
    },
    allowFields: {
      type: Object,
      default: () => {},
    },
    classShow: {
      type: String,
      default: "col-12 col-md-12",
    },
    title: {
      type: String,
    },
    refreshButton: {
      type: Boolean,
      default: true,
    },
    order_by: {
      type: String,
      default: "",
    },
    hasFilter: {
      type: Boolean,
      default: true,
    },
    showTotalRowsCount: {
      type: Boolean,
      default: true,
    },
    parentParams: {
      type: Object,
      default: null,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    showQuickFilter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [],
      columns: [],
      allowPaginate: true,
      total_pages: 0,
      totalRows: 0,
      filterHeaders: [],
      filter: false,
      page: 1,
      paramsData: {},
      paramsPage: {},
      classData: "col-12",
      isLoading: false,
      exportable: false,
      exportableLoading: false,
      resourceKey: null,
      permissions: [],
      firstLoad: true,
      deleteFilterLoading: false,
      clearInputGroup: false,
    };
  },
  computed: {
    roles() {
      return generateStoreGetters(["userInfo", "roles"]) || [];
    },
  },
  methods: {
    pathOr,
    isAdmin,
    async fillTable() {
      if (this.filterCatch) {
        const params = await this.getFilterCacheResource();
        if (params) {
          this.page = pathOr(1, ["page"], params);
          for (const key of Object.keys(params)) {
            this.paramsPage[key] = params[key];
          }
        }
      } else {
        this.paramsPage["page"] = 1;
      }
      this.paramsPage["per_page"] = this.perPage;
      if (this.order_by) {
        this.paramsPage["order_by"] = this.order_by;
      }
      if (this.parentParams) {
        this.paramsPage = { ...this.paramsPage, ...this.parentParams };
      }

      await this.getItems();
    },
    showFilter() {
      this.filter = !this.filter;
      if (this.filter) {
        this.classData = "col-12 col-md-10";
      } else {
        this.classData = "col-12";
      }
    },
    paging(page) {
      this.paramsPage["page"] = page;
      this.getItems();
    },
    deepFind(obj, path) {
      var paths = path.split("."),
        current = obj,
        i;
      if (paths.length > 0) {
        for (i = 0; i < paths.length; ++i) {
          if (current[paths[i]] == undefined) {
            return undefined;
          } else {
            current = current[paths[i]];
          }
        }
      }
      return current;
    },
    async getItems() {
      try {
        this.isLoading = true;
        this.totalRows = 0;
        const { per_page, order_by, page, locale_id, ...otherFilter } =
          this.paramsPage;
        this.paramsData = otherFilter;

        const response = await this.$httpService.get(this.url, this.paramsPage);
        const data = pathOr([], ["data", "data"], response);
        this.items = pathOr([], ["data", "data", "result"], response);
        this.filterHeaders = pathOr([], ["data", "filters"], response).map(
          (x) => {
            return {
              ...x,
              loader: !x.open,
            };
          }
        );
        this.totalRows = pathOr(null, ["total"], data);
        this.total_pages = pathOr(null, ["total_pages"], data);
        this.exportable = pathOr(false, ["data", "exportable"], response);
        this.resourceKey = pathOr(null, ["data", "resource"], response);
        this.permissions = pathOr([], ["data", "permissions"], response);
        this.$emit("updatePermissions", this.permissions);
        const other = pathOr(null, ["data", "other"], response);
        this.$emit("getOther", other);
        this.$emit("getItems", this.items);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
        this.firstLoad = false;
      }
    },
    importExcel() {
      this.$emit("importExcel");
    },
    async exportData() {
      try {
        this.exportableLoading = true;
        const url =
          this.$config.api_url +
          this.$config.resources.exportData.replace("{0}", this.resourceKey);
        const payload = {
          filters: this.paramsData,
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.exportableLoading = false;
      }
    },
    quickFilter(value) {
      this.isLoading = true;
      this.paramsPage["search_txt"] = value;
      this.fillTable();
    },
    async handleDeleteFilterCache() {
      try {
        this.deleteFilterLoading = true;
        await this.deleteFilterCacheResource();
        this.clearInputGroup = true;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.deleteFilterLoading = false;
        setTimeout(() => (this.clearInputGroup = false), 500);
      }
    },
  },
  created() {
    this.fillTable();
  },
};
</script>
